import React, { useMemo } from 'react';
import SmartFlashCardFeature from '../../../components/features/smartFlashCardsFeatures/smartFlashCardFeature';
import { useNoteState } from '../../../context/noteContexts/noteContext';
import { useColorContext } from '../../../context/colorContext';

const toFlashcardPayloadList = (value) => {
	if (Array.isArray(value)) {
		return value.filter((item) => item && typeof item === 'object');
	}

	if (value && typeof value === 'object') {
		if (Array.isArray(value.data)) {
			return value.data.filter((item) => item && typeof item === 'object');
		}
		return [value];
	}

	return [];
};

const KinesthicView = ({ flashcardJsonList: flashcardJsonListProp }) => {
	const { listJson_content_flashCards } = useNoteState();
	const { bgPrimary, textPrimary, textSecondary, activeAccent } = useColorContext();

	const flashcardJsonList = useMemo(() => {
		if (flashcardJsonListProp !== undefined) {
			return toFlashcardPayloadList(flashcardJsonListProp);
		}
		return toFlashcardPayloadList(listJson_content_flashCards);
	}, [flashcardJsonListProp, listJson_content_flashCards]);

	if (flashcardJsonList.length === 0) {
		return (
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					minHeight: '56vh',
					color: textSecondary,
					fontSize: '1rem',
				}}
			>
				No kinesthetic flashcards available yet.
			</div>
		);
	}

	return (
		<div
			style={{
				width: '100%',
				maxWidth: '1280px',
				margin: '0 auto',
				display: 'flex',
				flexDirection: 'column',
				gap: '1.25rem',
				padding: '0.2rem 0.25rem 1rem',
				background: bgPrimary,
			}}
		>
			{flashcardJsonList.map((flashcardJson, index) => {
				const title = flashcardJson?.title
					|| flashcardJson?.metadata?.documentTitle
					|| `Flashcards ${index + 1}`;

				return (
					<section
						key={`kinesthetic-flashcards-${index}`}
						style={{
							padding: '1rem 1rem 1.15rem',
							borderRadius: '1.1rem',
							border: `1px solid ${activeAccent}2b`,
							background: `linear-gradient(180deg, ${activeAccent}10 0%, transparent 100%)`,
						}}
					>
						<SmartFlashCardFeature
							result={flashcardJson}
							layout={{
								maxWidth: '100%',
								minHeight: '58vh',
								cardMinHeight: '36vh',
							}}
						/>
					</section>
				);
			})}
		</div>
	);
};

export default KinesthicView;
